import { PermissionEnum, PermissionDesctiptionEnum } from 'api/permissions/permissions.enum';
import {
  OwnerPermissionsIdSortEnum,
  OwnerPermissionsReaderNameSortEnum,
  OwnerPermissionsQueryKeysEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useOwnerQueryKeys } from 'hooks/useOwnerQueryKeys/useOwnerQueryKeys';
import { Table } from 'ui/table/Table';

export const OwnerEffectiveTerminalsPermissionsTableHeader = () => {
  const { ownerPermissionsEffectiveQueryKey } = useOwnerQueryKeys();

  const { formatMessage } = useLocale();

  const premissionsFilterItems = Object.values(PermissionEnum).map((permission) => ({
    name: formatMessage({ id: PermissionDesctiptionEnum[permission] }),
    filterBy: permission,
  }));

  return (
    <>
      <Table.HeaderSortItem
        queryKey={ownerPermissionsEffectiveQueryKey}
        sortBy={OwnerPermissionsIdSortEnum}
        queryHeader={formatMessage({ id: AppMessages['permissions.table.header.id'] })}
      />

      <Table.HeaderSortItem
        queryKey={ownerPermissionsEffectiveQueryKey}
        sortBy={OwnerPermissionsReaderNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['permissions.table.header.readerName'] })}
      />

      <Table.HeaderFilterItem
        queryKey={ownerPermissionsEffectiveQueryKey}
        queryName={OwnerPermissionsQueryKeysEnum.REJESTRUJ_ODBICIE}
        filterItems={premissionsFilterItems}
        queryHeader={formatMessage({ id: AppMessages['permissions.table.header.registerRecord'] })}
        queryHeaderDescriptions={PermissionDesctiptionEnum}
        maxWidth="none"
      />

      <Table.HeaderFilterItem
        queryKey={ownerPermissionsEffectiveQueryKey}
        queryName={OwnerPermissionsQueryKeysEnum.OTWIERAJ_ZAMEK}
        filterItems={premissionsFilterItems}
        queryHeader={formatMessage({ id: AppMessages['permissions.table.header.openLock'] })}
        queryHeaderDescriptions={PermissionDesctiptionEnum}
        maxWidth="none"
      />

      <Table.HeaderFilterItem
        queryKey={ownerPermissionsEffectiveQueryKey}
        queryName={OwnerPermissionsQueryKeysEnum.REJESTRUJ_RCP}
        filterItems={premissionsFilterItems}
        queryHeader={formatMessage({ id: AppMessages['permissions.table.header.registerRcp'] })}
        queryHeaderDescriptions={PermissionDesctiptionEnum}
        maxWidth="none"
      />
    </>
  );
};
